<template>
  <div class="layout-app" :class="current_mode" :dir="$page.props.dir">
    <!-- ponytail: pengumuman hardcode, hapus blok ini + showUpdateNotice setelah update selesai -->
    <div v-if="showUpdateNotice" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" @click.self="showUpdateNotice = false">
      <div class="relative w-full max-w-md rounded-xl bg-white p-6 pt-8 text-center text-gray-800 shadow-xl" role="dialog" aria-modal="true">
        <button class="absolute right-3 top-3 text-xl leading-none text-gray-400 hover:text-gray-600" aria-label="Tutup" @click="showUpdateNotice = false">&times;</button>
        <div class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-500">
          <!-- heroicons arrow-path -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="h-8 w-8" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
        </div>
        <h3 class="mb-2 text-lg font-bold">Pemberitahuan Pembaruan Sistem</h3>
        <p class="mb-4 text-sm text-gray-600">Akan ada pembaruan sistem Helpdesk. Mohon simpan pekerjaan Anda sebelum waktu tersebut.</p>
        <div class="mb-5 inline-flex items-center gap-2 rounded-full bg-amber-50 px-4 py-1.5 text-sm font-semibold text-amber-700">
          <!-- heroicons clock -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Hari ini, pukul 17.30
        </div>
        <button class="btn-indigo w-full" @click="showUpdateNotice = false">Mengerti</button>
      </div>
    </div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col" style="min-height: 125vh">
        <div class="md:flex md:shrink-0 ">
          <div class="md:shrink-0 md:py-2 md:w-60 flex items-center justify-between md:justify-center sidebar-left-top">
            <Link class="mt-1" href="/">
              <logo class="help-desk-logo" />
            </Link>
            <dropdown class="md:hidden small-menu" placement="bottom-end">
              <template #default>
                <svg class="w-6 h-6 mobile-menu-selector" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-hd-sidebar rounded shadow-lg">
                  <main-menu :auth="auth" />
                </div>
              </template>
            </dropdown>
          </div>
          <div class="w-full p-4 md:py-2 md:pr-12 md:pl-8 text-sm flex justify-between items-center top_bar">
            <div class="placement-top-left">
              <div class="welcome_text">{{ generateGreetings() }} <span>{{ $page.props.auth.user.first_name }}!</span></div>
              <div class="topbar-sub flex items-center gap-3">
                <span class="topbar-time">{{ time }}</span>
                <span class="topbar-divider">·</span>
                <div class="breadcrumb">
                  <Link :href="route('dashboard')"><icon class="w-3 h-3" name="home" /></Link>
                  <span class="b-item">/</span>
                  <Link v-if="edit_route" :href="route(edit_route)" class="capitalize">{{ edit_route }}</Link>
                  <span v-if="edit_route" class="b-item">/</span>
                  <span class="b-item">{{ __(title) }}</span>
                </div>
              </div>
            </div>
            <div class="placement-top-right flex items-center gap-4 px-2">
              <NotificationDropdown />

              <button class="theme-toggle-btn focus:outline-none group" title="Toggle theme" @click="switchMode">
                <svg v-if="current_mode === 'light'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-6 h-6 topbar-icon group-hover:text-green-700 transition-colors">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="w-6 h-6 topbar-icon group-hover:text-yellow-500 transition-colors">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                </svg>
              </button>

              <!-- 👤 User Dropdown -->
              <dropdown class="select_user" placement="bottom-end">
                <template #default>
                  <div class="flex items-center cursor-pointer gap-2 ud-trigger">
                    <div class="ud-avatar">
                      <img
                        v-if="$page.props.auth.user.photo"
                        :src="$page.props.auth.user.photo"
                        :alt="$page.props.auth.user.first_name"
                        class="w-full h-full object-cover"
                      />
                      <span v-else class="ud-initials">
                        {{ ($page.props.auth.user.first_name || '?')[0].toUpperCase() }}
                      </span>
                    </div>
                    <span class="ud-name hidden md:inline">
                      {{ $page.props.auth.user.first_name }}
                      {{ $page.props.auth.user.last_name }}
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="ud-chevron">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </div>
                </template>
                <template #dropdown>
                  <div :class="['ud-menu', current_mode === 'dark' ? 'ud-menu--dark' : '']">
                    <!-- Header -->
                    <div class="ud-menu-header">
                      <div class="ud-menu-avatar">
                        <img
                          v-if="$page.props.auth.user.photo"
                          :src="$page.props.auth.user.photo"
                          :alt="$page.props.auth.user.first_name"
                          class="w-full h-full object-cover"
                        />
                        <span v-else class="ud-initials">
                          {{ ($page.props.auth.user.first_name || '?')[0].toUpperCase() }}
                        </span>
                      </div>
                      <div class="ud-menu-userinfo">
                        <p class="ud-menu-name">{{ $page.props.auth.user.first_name }} {{ $page.props.auth.user.last_name }}</p>
                        <p class="ud-menu-email">{{ $page.props.auth.user.email }}</p>
                      </div>
                    </div>
                    <div class="ud-divider"></div>
                    <!-- Items -->
                    <div class="ud-menu-body">
                      <Link class="ud-menu-item" :href="route('users.edit.profile')">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="ud-item-icon">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                        </svg>
                        {{ __('Edit Profile') }}
                      </Link>
                      <Link class="ud-menu-item ud-menu-item--danger" :href="route('logout')" method="delete" as="button">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="ud-item-icon">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
                        </svg>
                        {{ __('Logout') }}
                      </Link>
                    </div>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>

        <div class="md:flex md:flex-grow md:overflow-hidden">
          <div class="hidden md:block sidebar-wrap shrink-0" :class="{ 'sidebar-wrap--collapsed': sidebarCollapsed }">
            <main-menu class="sidebar overflow-y-auto" />
            <button class="sidebar-toggle-btn" :title="sidebarCollapsed ? __('Expand menu') : __('Collapse menu')" @click="toggleSidebar">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-3.5 h-3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
              </svg>
            </button>
          </div>
          <div class="md:flex-1 md:overflow-y-auto content-area" scroll-region>
            <flash-messages />
            <div class="sec-cont"><slot /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ── Trigger ─────────────────────────────────────────── */
.ud-trigger { padding: 6px 10px; border-radius: 10px; transition: background 0.15s; }
.ud-trigger:hover { background: rgba(21,128,61,0.08); }

.ud-avatar {
  width: 32px; height: 32px; border-radius: 50%; overflow: hidden; flex-shrink: 0;
  background: linear-gradient(135deg, #15803d, #166534);
  display: flex; align-items: center; justify-content: center;
}
.ud-initials { color: #fff; font-size: 13px; font-weight: 600; line-height: 1; }
.ud-name { font-size: 13px; font-weight: 500; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #1e293b; }
.dark .ud-name { color: #ffffff; }
.ud-chevron { width: 14px; height: 14px; opacity: 0.5; }

/* ── Dropdown Menu ───────────────────────────────────── */
.ud-menu {
  min-width: 220px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.12);
  overflow: hidden;
  font-size: 13px;
}

/* Header */
.ud-menu-header {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 16px 12px;
}
.ud-menu-avatar {
  width: 38px; height: 38px; border-radius: 50%; overflow: hidden; flex-shrink: 0;
  background: linear-gradient(135deg, #15803d, #166534);
  display: flex; align-items: center; justify-content: center;
}
.ud-menu-avatar .ud-initials { font-size: 15px; }
.ud-menu-userinfo { overflow: hidden; }
.ud-menu-name { font-weight: 600; color: #111827; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ud-menu-email { font-size: 11px; color: #6b7280; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 1px; }

.ud-divider { height: 1px; background: #f3f4f6; margin: 0; }

/* Items */
.ud-menu-body { padding: 6px; }
.ud-menu-item {
  display: flex; align-items: center; gap: 10px;
  padding: 9px 12px; border-radius: 8px;
  color: #374151; font-weight: 500;
  transition: background 0.13s, color 0.13s;
  text-decoration: none; width: 100%; text-align: left;
  cursor: pointer; border: none; background: none;
}
.ud-menu-item:hover { background: #f0fdf4; color: #15803d; }
.ud-item-icon { width: 16px; height: 16px; flex-shrink: 0; }
.ud-menu-item--danger { color: #374151; }
.ud-menu-item--danger:hover { background: #fff1f2; color: #dc2626; }

/* ── Dark Mode ───────────────────────────────────────── */
.ud-menu--dark {
  background: #1e2433;
  border-color: #2d3748;
  box-shadow: 0 10px 40px rgba(0,0,0,0.4);
}
.ud-menu--dark .ud-menu-name { color: #f1f5f9; }
.ud-menu--dark .ud-menu-email { color: #94a3b8; }
.ud-menu--dark .ud-divider { background: #2d3748; }
.ud-menu--dark .ud-menu-item { color: #cbd5e1; }
.ud-menu--dark .ud-menu-item:hover { background: rgba(74,222,128,0.08); color: #4ade80; }
.ud-menu--dark .ud-menu-item--danger:hover { background: rgba(220,38,38,0.12); color: #f87171; }
</style>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import NotificationDropdown from '@/Shared/NotificationDropdown.vue'
import { Link } from '@inertiajs/vue3'
import moment from 'moment'
import axios from 'axios'

export default {
  components: {
    Icon,
    Logo,
    Dropdown,
    MainMenu,
    FlashMessages,
    NotificationDropdown,
    NotificationDropdown,
    Link,
  },
  props: { title: String },
  data() {
    return {
      time: '',
      current_mode: 'light',
      edit_route: '',
      showNotification: false,
      notificationMessage: '',
      sidebarCollapsed: false,
      _heartbeatInterval: null,
      showUpdateNotice: true,
    }
  },
  watch: {
    // Layout persistent → tidak remount saat pindah halaman, jadi buka ulang popup tiap URL berganti
    '$page.url'() { this.showUpdateNotice = true },
  },
  computed: {
    selected_language() { return this.$page.props.languages.find(l => l.code === this.$page.props.locale) },
    languages_except_selected() { return this.$page.props.languages.filter(l => l.code !== this.$page.props.locale) },
  },
  created() {
    this.moment = moment
    this.current_mode = localStorage.getItem('current_mode') || this.current_mode
    this.sidebarCollapsed = localStorage.getItem('sidebar_collapsed') === '1'
    this.time = this.moment().format('MMMM Do YYYY, h:mm A')
    setInterval(() => { this.time = this.moment().format('MMMM Do YYYY, h:mm A') }, 1000)
    this.detectCurrentUrl()
  },
  mounted() {
    this._sendHeartbeat()
    this._heartbeatInterval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        this._sendHeartbeat()
      }
    }, 60000)
    document.addEventListener('visibilitychange', this._onVisibilityChange)
  },
  beforeUnmount() {
    clearInterval(this._heartbeatInterval)
    document.removeEventListener('visibilitychange', this._onVisibilityChange)
  },
  updated() { this.detectCurrentUrl() },
  methods: {
    _sendHeartbeat() {
      axios.post('/dashboard/heartbeat').catch(() => {})
    },
    _onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this._sendHeartbeat()
      }
    },
    triggerNotification(msg) {
      this.notificationMessage = msg
      this.showNotification = true
    },
    generateGreetings() {
      const h = this.moment().format('HH')
      return h < 12 ? 'Selamat Pagi' : h < 15 ? 'Selamat Siang' : h < 18 ? 'Selamat Sore' : h < 20 ? 'Selamat Malam' : 'Hello'
    },
    switchMode() {
      this.current_mode = this.current_mode === 'light' ? 'dark' : 'light'
      localStorage.setItem('current_mode', this.current_mode)
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
      localStorage.setItem('sidebar_collapsed', this.sidebarCollapsed ? '1' : '0')
    },
    detectCurrentUrl() {
      const u = this.$page.url.split('/')
      const last = u[u.length - 1]
      const penult = u[u.length - 2]
      this.edit_route = ['edit','create'].includes(last) || penult === 'tickets' ? u[2] : ''
    },
  },
}
</script>
